module.exports = "function rule(user, context, callback) {\n  mongo('mongodb://user:password@server:port/db', function(db) {\n    var users = db.collection('users');\n    users.findOne({ email: user.email }, function(err, mongoUser) {\n      if (err) return callback(err);\n      if (!mongoUser) return callback(null, user, context);\n\n      context.idToken['https://example.com/foo'] = mongoUser.foo;\n      callback(null, user, context);\n    });\n  });\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/homepage/rule-templates/mongodb.js.txt
// module id = 1429
// module chunks = 0